// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.commutably {
  --toaster-left: 0;
  --toaster-right: 0;
  --toaster-margin-x: auto;
  --toaster-margin-bottom: 1rem;

  --toast-margin-y: 0;
  --toast-width: 30em;
  --toast-max-width: calc(100% - 2em);
  --toast-font-size: 1em;
  --toast-dismiss-button-font-size: 0.9em;

  --toast-progress-height: 0.2em;
  --toast-progress-value-background: white;
}

@media screen and (min-width: 430px) {
  .commutably {
    --toaster-right: auto;
    --toaster-margin-x: 2em;
  }
}
`, "",{"version":3,"sources":["webpack://./src/theme/components/Toaster.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,wBAAwB;EACxB,6BAA6B;;EAE7B,mBAAmB;EACnB,mBAAmB;EACnB,mCAAmC;EACnC,sBAAsB;EACtB,uCAAuC;;EAEvC,8BAA8B;EAC9B,wCAAwC;AAC1C;;AAEA;EACE;IACE,qBAAqB;IACrB,uBAAuB;EACzB;AACF","sourcesContent":[".commutably {\n  --toaster-left: 0;\n  --toaster-right: 0;\n  --toaster-margin-x: auto;\n  --toaster-margin-bottom: 1rem;\n\n  --toast-margin-y: 0;\n  --toast-width: 30em;\n  --toast-max-width: calc(100% - 2em);\n  --toast-font-size: 1em;\n  --toast-dismiss-button-font-size: 0.9em;\n\n  --toast-progress-height: 0.2em;\n  --toast-progress-value-background: white;\n}\n\n@media (--screen-sm) {\n  .commutably {\n    --toaster-right: auto;\n    --toaster-margin-x: 2em;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
